<section class="online-visit-page" *ngIf="!loading">
    <div class="visita-online-wrapper">
        <div class="left-column">
            <div class="header-section">
                <h1 class="typography-title-xl textPrimary-color">
                    {{ 'online_visit.title' | translate }}
                </h1>
                <p class="typography-body-l-medium textSecondary-color">
                    {{ 'online_visit.subtitle' | translate }}
                </p>
            </div>

            <div class="video-section">
                <div class="video-wrapper" *ngIf="videoPlaying && linkVideo; else videoThumbnail">
                    <iframe
                        [src]="linkVideo"
                        frameborder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowfullscreen>
                    </iframe>
                </div>
                <ng-template #videoThumbnail>
                    <div class="video-thumbnail" (click)="playVideo()">
                        <img src="assets/images/news/VisitaVirtual.png" [alt]="'online_visit.title' | translate" />
                        <div class="video-overlay">
                            <div class="play-button">
                                <svg width="35" height="30" viewBox="0 0 35 30" fill="none" aria-hidden="true">
                                    <polygon points="0,0 35,15 0,30" fill="white" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>

            <div class="proceso-section">
                <h2 class="typography-title-m textPrimary-color">
                    {{ 'online_visit.process_title' | translate }}
                </h2>

                <div class="instruccion" *ngFor="let step of instructions; let i = index">
                    <div class="numero-circle">
                        <span class="typography-title-s">{{ i + 1 }}</span>
                    </div>
                    <div class="instruccion-content">
                        <p class="typography-body-l-regular textPrimary-color">
                            {{ step.titleKey | translate }}
                        </p>
                        <p class="typography-body-m-light textPrimary-color">
                            {{ step.descriptionKey | translate }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="right-column">
            <div class="card form-card">
                <h2 class="typography-title-m textPrimary-color">
                    {{ 'online_visit.form_title' | translate }}
                </h2>

                <alert *ngIf="cooldown?.isBlocked" type="warning">
                    {{ 'online_visit.cooldown_message' | translate:{ days: (cooldown?.remainingDays || cooldown?.cooldownDays) } }}
                </alert>

                <alert *ngIf="successMessageVisible" type="success" [closable]="true" (closed)="successMessageVisible = false">
                    {{ 'online_visit.success_message' | translate }}
                </alert>

                <alert *ngIf="errorMessageVisible" type="error" [closable]="true" (closed)="errorMessageVisible = false">
                    {{ 'online_visit.error_message' | translate }}
                </alert>

                <div class="form-content">
                    <div class="form-section">
                        <div class="input-row">
                            <div class="input-field">
                                <label class="typography-body-m-medium textPrimary-color">{{ 'online_visit.first_name' | translate }}</label>
                                <input
                                    type="text"
                                    name="firstName"
                                    [(ngModel)]="form.firstName"
                                    class="input-disabled typography-body-m-regular"
                                    [disabled]="true"
                                />
                            </div>
                            <div class="input-field">
                                <label class="typography-body-m-medium textPrimary-color">{{ 'online_visit.last_name' | translate }}</label>
                                <input
                                    type="text"
                                    name="lastName"
                                    [(ngModel)]="form.lastName"
                                    class="input-disabled typography-body-m-regular"
                                    [disabled]="true"
                                />
                            </div>
                        </div>
                        <div class="input-row">
                            <div class="input-field">
                                <label class="typography-body-m-medium textPrimary-color">{{ 'online_visit.email' | translate }}</label>
                                <input
                                    type="email"
                                    name="email"
                                    [(ngModel)]="form.email"
                                    class="input-disabled typography-body-m-regular"
                                    [disabled]="true"
                                />
                            </div>
                            <div class="input-field">
                                <label class="typography-body-m-medium textPrimary-color">{{ 'online_visit.phone' | translate }}</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    [(ngModel)]="form.phone"
                                    [ngClass]="{ 'input-disabled': isBlocked || submitting, 'input-active': !isBlocked && !submitting }"
                                    [disabled]="isBlocked || submitting"
                                    placeholder="+34 666 123 456"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="form-section">
                        <div class="checkbox-group">
                            <label class="typography-body-m-medium textPrimary-color">
                                {{ 'online_visit.select_material' | translate }}
                            </label>
                            <div class="checkbox-row materiales-row">
                                <div
                                    class="checkbox-item"
                                    *ngFor="let mat of materialsList"
                                    [ngClass]="{ disabled: isBlocked || submitting }"
                                    (click)="toggleMaterial(mat.key)"
                                >
                                    <div class="custom-checkbox" [ngClass]="{ checked: form.materials[mat.key] }">
                                        <svg *ngIf="form.materials[mat.key]" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                            <path d="M13.3 4.3L6 11.6L2.7 8.3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <span class="typography-body-m-regular textPrimary-color">{{ mat.labelKey | translate }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="checkbox-group">
                            <label class="typography-body-m-medium textPrimary-color">
                                {{ 'online_visit.select_spaces' | translate }}
                            </label>
                            <div class="checkbox-row espacios-row">
                                <div
                                    class="checkbox-item"
                                    *ngFor="let space of spacesList"
                                    [ngClass]="{ disabled: isBlocked || submitting }"
                                    (click)="toggleSpace(space.key)"
                                >
                                    <div class="custom-checkbox" [ngClass]="{ checked: form.spaces[space.key] }">
                                        <svg *ngIf="form.spaces[space.key]" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                            <path d="M13.3 4.3L6 11.6L2.7 8.3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <span class="typography-body-m-regular textPrimary-color">{{ space.labelKey | translate }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-section">
                        <div class="fecha-group">
                            <label class="typography-body-m-medium textPrimary-color">
                                {{ 'online_visit.select_dates' | translate }}
                            </label>
                            <mat-form-field class="w-full border border-divider fecha-field">
                                <input
                                    class="typography-body-m-regular placeholder:!text-text-tertiary !tracking-normal"
                                    matInput
                                    [matDatepicker]="picker"
                                    [matDatepickerFilter]="dateFilter"
                                    [min]="minDate"
                                    [(ngModel)]="form.selectedDate"
                                    [placeholder]="datePlaceholder"
                                    [disabled]="isBlocked || submitting"
                                    readonly
                                />
                                <mat-datepicker-toggle [disableRipple]="true" matIconSuffix [for]="picker">
                                    <mat-icon matDatepickerToggleIcon>
                                        <img src="assets/icons/datepicker.svg" alt="date" />
                                    </mat-icon>
                                </mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="checkbox-group">
                            <label class="typography-body-m-medium textPrimary-color">
                                {{ 'online_visit.select_time_slots' | translate }}
                            </label>
                            <div class="checkbox-row franjas-row">
                                <div
                                    class="checkbox-item"
                                    *ngFor="let time of timeSlotsList"
                                    [ngClass]="{ disabled: isBlocked || submitting }"
                                    (click)="toggleTimeSlot(time.key)"
                                >
                                    <div class="custom-checkbox" [ngClass]="{ checked: form.timeSlots[time.key] }">
                                        <svg *ngIf="form.timeSlots[time.key]" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                            <path d="M13.3 4.3L6 11.6L2.7 8.3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <span class="typography-body-m-regular textPrimary-color">{{ time.labelKey | translate }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-section">
                        <label class="typography-body-m-medium textPrimary-color">
                            {{ 'online_visit.comments_label' | translate }}
                        </label>
                        <textarea
                            name="comments"
                            [(ngModel)]="form.comments"
                            class="textarea-active typography-body-m-light"
                            [placeholder]="'online_visit.comments_placeholder' | translate"
                            [disabled]="isBlocked || submitting"
                            maxlength="250"
                            rows="4"
                        ></textarea>
                        <span class="typography-body-s textSecondary-color char-counter">
                            {{ form.comments.length }}/250
                        </span>
                    </div>

                    <div class="form-actions">
                        <app-button
                            [primary]="true"
                            skin="ctop"
                            size="large"
                            [disabled]="!isFormValid() || submitting || isBlocked"
                            [loading]="submitting"
                            (onClick)="submitForm()"
                        >
                            {{ 'online_visit.submit_button' | translate }}
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div *ngIf="loading" class="online-visit-loading">
    <span class="typography-body-m-regular">Loading...</span>
</div>
